import React from "react";

import { Dialog, Transition } from "@headlessui/react";

export const ReactModal = (props) => {
  return (
    // Use the `Transition` component at the root level
    <Transition appear={true} show={props.isOpen} as={React.Fragment}>
      <Dialog onClose={props.close}>
        {/*
          Use one Transition.Child to apply one transition to the backdrop...
        */}
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <button
            onClick={props.close}
            // the z-index is added so the modal always appear above to the BoardRoom
            className={`fixed inset-0 bg-white/50 dark:bg-black/50 backdrop-blur-sm border-0 z-10 ${props.buttonClassName || ""}`}
          />
        </Transition.Child>

        {/*
          ...and another Transition.Child to apply a separate transition
          to the contents.
        */}

        {props.children}
      </Dialog>
    </Transition>
  );
};

ReactModal.Card = ({ children, className, dialogPanelClassName, rootElClassName = "" }) => {
  return (
    <Transition.Child
      as={React.Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0 scale-95"
      enterTo="opacity-100 scale-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100 scale-100"
      leaveTo="opacity-0 scale-95"
    >
      <div className={`fixed inset-0 overflow-y-auto z-50 ${rootElClassName}`}>
        {/* Container to center the panel */}
        <div className="flex min-h-full items-center justify-center p-4 box-border">
          {/* The actual dialog panel  */}
          <Dialog.Panel className={dialogPanelClassName || "mx-auto"}>
            {/* <div className="flex fixed inset-0 flex-col items-center justify-between overflow-x-hidden overflow-y-scroll px-8"> */}
            <div className= {className || "md:mt-[10vh] w-full max-w-[90vw] md:max-w-xl rounded-lg bg-white p-8 shadow-xl dark:bg-mono-900/50 dark:shadow-none dark:shadow-none" }>
              {children}
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Transition.Child>
  );
};
